import { OrderExportModel } from "./OrderExport.model";

export class OrderExport extends OrderExportModel {
    // Add custom methods here
}
